/*
------------------------------------------------------------------------------------
重複防止ランダム数生成関数（固定値あり）
------------------------------------------------------------------------------------
【使用方法】
「rdmFunc(num1, num2, array)」の形式にて関数実行 
第一引数は抽出範囲数、第二引数は最大範囲数、第三引数は必ず含まれる配列固定値となります

任意の範囲数から特定の範囲内での重複しない乱数を配列として返します。
ただし、配列指定した数値については必ず入るものとします

【サンプルコード】
------------------------------------------------------------------------------------
var result = module.rdmFunc(4, 10, [1, 2]); // 1と2が必ず含まれる4/10の乱数
console.log(result);
------------------------------------------------------------------------------------
*/

function getRandomRange(minRange, maxRange, keepArray) { // 引数：抽出数, 最大数, 固定値配列

	// 固定値を入れながら乱数を発生
	var resultArray1 = keepArray; // 選択肢用配列へ固定値配列を代入
	for (var i = 0; i < minRange; i++) {
		if (resultArray1.length < minRange) {
			var selRdm1 = (Math.ceil(Math.random()*maxRange))*2; // 偶数のみの乱数は「*2」を末尾に付ける
			for (var j = 0; j < resultArray1.length; j++) {
				if (resultArray1[j] === selRdm1) {
					j = -1;
					selRdm1 = (Math.ceil(Math.random()*maxRange))*2; // 偶数のみの乱数は「*2」を末尾に付ける
				}
			}
			resultArray1.push(selRdm1);
		}
	}

	// 固定値を含めてシャッフル
	var reRdm = [];
	var resultArray2 = [];
	for (i = 0; i < resultArray1.length; i++) {
		var selRdm2 = (Math.floor(Math.random()*resultArray1.length)); // 1からの乱数はMath.ceilにする
		for (j = 0; j < resultArray1.length; j++) {
			if (reRdm[j] === selRdm2) {
				j = -1;
				selRdm2 = (Math.floor(Math.random()*resultArray1.length)); // 1からの乱数はMath.ceilにする
			}
		}
		reRdm[i] = selRdm2;
		resultArray2[i] = resultArray1[reRdm[i]];
	}
	
	return resultArray2;
}
export default {getRandomRange}
